import TextArea from "antd/es/input/TextArea";
import styled from "styled-components";

export const StyledBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    background-color: ${({ theme }) => theme.primaryBackground};
    border-radius: 10px;
`;

export const StyledTextArea = styled(TextArea)`
    background-color: ${({ theme }) => theme.itemBackground};

    &&::placeholder {
        color: ${({ theme }) => theme.disabledTypographyColor};
    }
`;

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: space-between;
    height: 100%;
`;

export const StyledBottomSheetTop = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 8px;
    align-items: center;
`;
